{
  "$id": "wealthlane://forms/customer-success-automation",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../customer-success-automation.domain.json",
  "properties": {
    "sourceCompanyId": {
      "$ref": "module://customer-success-automation#properties/sourceCompanyId",
      "required": true,
      "excludeOptionValuesFrom": "destinationCompanyId"
    },
    "sourceRoleId": {
      "$ref": "module://customer-success-automation#properties/sourceRoleId",
      "required": true,
      "dependsOn": "sourceCompanyId",
      "paramMap": {
        "companyId": "sourceCompanyId"
      },
      "disabledWhen": {
        "field": "#/properties/sourceCompanyId",
        "isEmpty": true
      }
    },
    "destinationCompanyId": {
      "$ref": "module://customer-success-automation#properties/destinationCompanyId",
      "required": true,
      "excludeOptionValuesFrom": "sourceCompanyId"
    },
    "destinationRoleId": {
      "$ref": "module://customer-success-automation#properties/destinationRoleId",
      "required": true,
      "dependsOn": "destinationCompanyId",
      "paramMap": {
        "companyId": "destinationCompanyId"
      },
      "disabledWhen": {
        "field": "#/properties/destinationCompanyId",
        "isEmpty": true
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_CUSTOMER_SUCCESS_AUTOMATION",
      "refreshEntities": ["RolePublish", "RoleMapping"],
      "invalidateQueries": ["getRolePublishList", "getAllowedRoleMappings"]
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "clearForm"
      }
    }
  }
}
